import { DropdownOption } from '@elxjs/ui'

export enum PRODUCTFAMILY_ITEMTYPE {
  ACCESSORY = 'ACCESSORY',
  PRODUCT = 'PRODUCT',
}

export const TYPE_LIST: DropdownOption[] = [
  { text: 'Acessório', value: 'Acessório' },
  { text: 'Consumível', value: 'Consumível' },
  { text: 'Major & Small', value: 'Produto Major Ou Small' },
]

export const JOURNEY_LIST: DropdownOption[] = [
  { text: 'Todos', value: 'Todas' },
  { text: 'Instalação', value: 'Instalação' },
  { text: 'Manutenção', value: 'Manutenção' },
  { text: 'Conversão', value: 'Conversão' },
]

export const STATUS_LIST: DropdownOption[] = [
  { text: 'Ativo', value: 'true' },
  { text: 'Inativo', value: 'false' },
]

export const PAGE_STATUS_LIST: DropdownOption[] = [
  { text: 'Ativo', value: 'active' },
  { text: 'Inativo', value: 'inactive' },
  { text: 'Rascunho', value: 'draft' },
]

export const PUBLISH_STATUS_LIST: DropdownOption[] = [
  { text: 'Publicado', value: 'true' },
  { text: 'Desativado', value: 'false' },
]

export const DATE_RANGE: DropdownOption[] = [
  { text: 'Últimos 7 dias', value: 1 },
  { text: 'Últimos 30 dias', value: 2 },
  { text: 'Últimos 6 meses', value: 3 },
  { text: 'Últimos 12 meses', value: 4 },
  { text: 'Mais de 12 meses', value: 5 },
]

export const TOPICS_LIST: DropdownOption[] = [
  { text: 'Instalação', value: 'instalação' },
  { text: 'Manutenção', value: 'manutenção' },
  { text: 'Compras on-line', value: 'compras on-line' },
  { text: 'Dicas', value: 'dicas' },
]

export const getTopicsList = (): DropdownOption[] => TOPICS_LIST.map((topic) => ({ ...topic }))

export const VISIBILITY_LIST: DropdownOption[] = [
  { text: 'Conteúdo', value: 'CONTENT' },
  { text: 'Home', value: 'HOME' },
  { text: 'PDC', value: 'PDC' },
]

export const PREPARATION_METHOD_LIST = [
  {
    value: 'MANUAL',
    text: 'Manual',
    description: 'Receitas em que o tempo, a potência ou a temperatura devem ser configurados manualmente.',
  },
  {
    value: 'ONLINE',
    text: 'Online',
    description:
      'Receitas em que o tempo, a potência ou a temperatura já estão pré-configurados no produto do usuário, podendo ser acessadas online.',
  },
]

export const DIFFICULTY_LIST = [
  { value: 'LOW', text: 'Fácil' },
  { value: 'MEDIUM', text: 'Médio' },
  { value: 'HIGH', text: 'Difícil' },
]

export const RECIPE_TYPE_LIST = [
  { value: 'SWEET', text: 'Doce' },
  { value: 'SALTY', text: 'Salgado' },
]

export interface SectionGroup {
  type: string
  label: string
  icon: string
  active: boolean
  pdp: boolean
  pdc: boolean
}

export const SECTION_GROUPS: SectionGroup[] = [
  {
    type: 'parts_and_accessories',
    label: 'Peças e complementos',
    icon: 'Settings.svg',
    active: false,
    pdp: true,
    pdc: false,
  },
  { type: 'first_steps', label: 'Primeiros Passos', icon: 'Info.svg', active: true, pdp: true, pdc: false },
  { type: 'getting_started', label: 'Primeiros Passos', icon: 'Info.svg', active: true, pdp: false, pdc: true },
  {
    type: 'maintenance_and_tips',
    label: 'Manutenção e Dicas de Uso',
    icon: 'Bell.svg',
    active: true,
    pdp: true,
    pdc: true,
  },
  { type: 'guides_and_manuals', label: 'Guias e Manuais', icon: 'Book.svg', active: true, pdp: true, pdc: true },
  {
    type: 'tutorials_and_reminders',
    label: 'Tutoriais e Lembretes',
    icon: 'Guides.svg',
    active: true,
    pdp: true,
    pdc: false,
  },
  {
    type: 'technical_assistance',
    label: 'Assistência Técnica',
    icon: 'Config.svg',
    active: false,
    pdp: true,
    pdc: true,
  },
]

export const CONTENT_TYPES = [
  { type: 'article', label: 'Artigos' },
  { type: 'doubt', label: 'Dúvidas' },
  { type: 'image', label: 'Imagem' },
  { type: 'manual_search', label: 'Busca por manuais' },
  { type: 'assistance_search', label: 'Busca por assistência' },
  { type: 'service_request', label: 'Solicitar serviços' },
  { type: 'routine_care', label: 'Rotinas de cuidado' },
  { type: 'text', label: 'Texto' },
  { type: 'title', label: 'Título' },
  { type: 'tutorial', label: 'Tutorial' },
  { type: 'sale', label: 'Venda' },
  { type: 'video', label: 'Vídeo' },
]

export interface TABLE_COLUMN {
  text: string
  value: string
  isDefault: boolean
  isDisabled?: boolean
}

export const DOUBTS_AND_ARTICLE_COLUMNS: TABLE_COLUMN[] = [
  { value: 'title', text: 'Título', isDefault: true },
  { value: 'status', text: 'Status', isDefault: true },
  { value: 'visibility', text: 'Visibilidade', isDefault: true },
  { value: 'categories', text: 'Categorias', isDefault: true },
  { value: 'products', text: 'Produtos', isDefault: true },
  { value: 'lastModifiedDateFormated', text: 'Última edição', isDefault: true },
  { value: 'search_terms', text: 'Termos de busca', isDefault: false },
  { value: 'themes', text: 'Temas / Assuntos', isDefault: false },
  { value: 'lastModifiedUser', text: 'Último editor', isDefault: false },
]

export const RECIPES_COLUMNS: TABLE_COLUMN[] = [
  { value: 'title', text: 'Título', isDefault: true, isDisabled: true },
  { value: 'status', text: 'Status', isDefault: true },
  { value: 'categories', text: 'Categorias', isDefault: true },
  { value: 'products', text: 'Produtos', isDefault: true },
  { value: 'recipeType', text: 'Tipo da receita', isDefault: true },
  { value: 'lastModifiedDateFormated', text: 'Última edição', isDefault: true },
  { value: 'preparationTime', text: 'Tempo de preparo', isDefault: false },
  { value: 'difficultyFormated', text: 'Dificuldade', isDefault: false },
  { value: 'lastModifiedUser', text: 'Último editor', isDefault: false },
]

export type RecipeStepType = 'LIST' | 'PARAGRAPH' | 'IMAGE' | 'HINT' | 'HELP'

export interface RecipeStepInterface {
  text: string
  type: RecipeStepType
}

export const RECIPE_STEP_TYPES: RecipeStepInterface[] = [
  { text: 'Lista', type: 'LIST' },
  { text: 'Parágrafo', type: 'PARAGRAPH' },
  { text: 'Imagem', type: 'IMAGE' },
  { text: 'Dica', type: 'HINT' },
  { text: 'Ajuda', type: 'HELP' },
]
